import { z } from 'zod';
import { IssueStatusFilterSchema } from '@/features/stacktrace/issues/-constants';
import { IssueSeverity, IssueStatus } from '@/features/stacktrace/issues/-query/type';
import { IssueTableColumns } from './-table/type';
const issueSeverityValues = Object.values(IssueSeverity) as [(typeof IssueSeverity)[keyof typeof IssueSeverity], ...(typeof IssueSeverity)[keyof typeof IssueSeverity][]];
export const IssueTableFilterSchema = z.object({
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(IssueTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc'),
  status: IssueStatusFilterSchema.default(IssueStatus.UNTOUCHED),
  freeText: z.string().optional(),
  severityIn: z.array(z.enum(issueSeverityValues)).optional(),
  severity: z.enum(issueSeverityValues).optional(),
  productionProductId: z.string().optional()
});